/** Returns true when the props are of type [[DayPickerRange]]. */
export function isDayPickerRange(props) {
  return props.mode === 'range';
}